import { render, staticRenderFns } from "./legalDescriptions.vue?vue&type=template&id=1a8aada2&scoped=true&"
import script from "./legalDescriptions.vue?vue&type=script&lang=js&"
export * from "./legalDescriptions.vue?vue&type=script&lang=js&"
import style0 from "./legalDescriptions.vue?vue&type=style&index=0&id=1a8aada2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8aada2",
  null
  
)

export default component.exports